"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4735],{

/***/ 76419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable global-require */ 
const { de: common  } = __webpack_require__(31668);
module.exports = {
    ...common
};


/***/ }),

/***/ 65345:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable global-require */ 
const { en: common  } = __webpack_require__(31668);
module.exports = {
    ...common
};


/***/ }),

/***/ 88054:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable global-require */ 
module.exports = {
    en: __webpack_require__(65345),
    de: __webpack_require__(76419)
};


/***/ }),

/***/ 2052:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable global-require */ 
module.exports = {
    common: __webpack_require__(50389)
};


/***/ }),

/***/ 47896:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable global-require */ 
module.exports = {
    common: __webpack_require__(1578)
};


/***/ }),

/***/ 91621:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable global-require */ 
module.exports = {
    en: __webpack_require__(47896),
    de: __webpack_require__(2052)
};


/***/ }),

/***/ 76965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ((0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
    code: prop_types__WEBPACK_IMPORTED_MODULE_0__.number,
    message: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
    stack: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.arrayOf)(prop_types__WEBPACK_IMPORTED_MODULE_0__.string),
    originalError: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        name: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
        code: prop_types__WEBPACK_IMPORTED_MODULE_0__.number,
        message: prop_types__WEBPACK_IMPORTED_MODULE_0__.string
    })
}));


/***/ }),

/***/ 38209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ src_AppError; },
  "b": function() { return /* binding */ withErrorHandling; }
});

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/index.js
var fn = __webpack_require__(10455);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ForceErrorHoC/index.js
var ForceErrorHoC = __webpack_require__(4354);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/i18/index.js + 16 modules
var i18 = __webpack_require__(46003);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./src/AppError/error-prop-type.js
var error_prop_type = __webpack_require__(76965);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(42866);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./src/routes.js + 1 modules
var routes = __webpack_require__(72578);
;// CONCATENATED MODULE: ./src/AppError/Error400.js







const Error400 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("400");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("BAD_REQUEST")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    t("DESC"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("PLEASE"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.support */.ZP.external.support,
                        children: t("CONTACT_US")
                    }),
                    " ",
                    t("FOR_FURTHER_ASSISTANCE"),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error400 = (Error400);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/global-context/hook.js
var hook = __webpack_require__(63841);
;// CONCATENATED MODULE: ./src/utils/nav-hooks/useCurrentPath.js


/** @type {() => string} */ function useCurrentPath() {
    const context = (0,hook/* default */.Z)();
    const router = (0,next_router.useRouter)();
    const { asPath  } = router || context;
    return asPath;
}
/* harmony default export */ var nav_hooks_useCurrentPath = (useCurrentPath);

;// CONCATENATED MODULE: ./src/AppError/Error401.js








const Error401 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("401");
    const currentPath = nav_hooks_useCurrentPath();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("NOT_AUTHORIZED")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    t("DESC"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("PLEASE"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: "".concat(routes/* default.logout */.ZP.logout, "?returnUrl=").concat(encodeURIComponent(currentPath)),
                        children: t("SIGN_IN")
                    }),
                    " ",
                    t("WITH_DIFFERENT_ACCOUNT"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.support */.ZP.external.support,
                        children: t("CONTACT_US")
                    }),
                    " ",
                    t("FOR_FURTHER_ASSISTANCE"),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error401 = (Error401);

;// CONCATENATED MODULE: ./src/AppError/Error403.js







const Error403 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("403");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("NOT_PERMITTED")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    t("DESC"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("PLEASE"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.support */.ZP.external.support,
                        children: t("CONTACT_US")
                    }),
                    " ",
                    t("FOR_FURTHER_ASSISTANCE"),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error403 = (Error403);

;// CONCATENATED MODULE: ./src/AppError/Error404.js





const Error404 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("404");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("NOT_FOUND")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: t("DESC")
            })
        ]
    });
};
/* harmony default export */ var AppError_Error404 = (Error404);

;// CONCATENATED MODULE: ./src/AppError/Error500.js







const Error500 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("500");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("SOMETHING_WENT_WRONG")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    t("DESC"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("PLEASE"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.support */.ZP.external.support,
                        children: t("CONTACT_US")
                    }),
                    " ",
                    t("FOR_FURTHER_ASSISTANCE"),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error500 = (Error500);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/atoms/ContentContainer/index.js
var ContentContainer = __webpack_require__(12985);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/color.js
var color = __webpack_require__(68657);
// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(89032);
;// CONCATENATED MODULE: ./src/AppError/ErrorDetails.js






const ErrorDetails = (param)=>/*#__PURE__*/ {
    let { error  } = param;
    return (0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
        mx: true,
        md: 10,
        lg: 8,
        center: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "panel ".concat(color/* bgColorBlack */.ZH),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                className: "".concat(color/* colorWhite */.A2, " px-5 py-5"),
                children: JSON.stringify(error, null, 2)
            })
        })
    });
};
ErrorDetails.propTypes = {
    error: error_prop_type/* default */.Z
};
/* harmony default export */ var AppError_ErrorDetails = (config/* publicConfig.DEBUG_MODE */.mn.DEBUG_MODE ? ErrorDetails : ()=>null);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Layout/index.js + 1 modules
var Layout = __webpack_require__(71412);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/index.js + 3 modules
var SimpleTemplate = __webpack_require__(35449);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Header/index.js + 6 modules
var Header = __webpack_require__(38529);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./src/prerendered-logo.js
var prerendered_logo = __webpack_require__(25476);
;// CONCATENATED MODULE: ./src/AppError/ErrorLayout.js









/** @type {React.FC<{ children: React.ReactNode, extra: React.ReactNode }>} */ const ErrorLayout = (param)=>/*#__PURE__*/ {
    let { children , extra  } = param;
    return (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default.Header */.Z.Header, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                    logo: prerendered_logo/* default */.ZP
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default.Body */.Z.Body, {
                className: color/* bgColorBlack2 */.vk,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleTemplate/* default */.Z, {
                        children: children
                    }),
                    extra && /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
                        className: "pt-9 pt-9--md pb-18 pb-18--md",
                        children: extra
                    })
                ]
            })
        ]
    });
};
ErrorLayout.propTypes = {
    children: prop_types.node,
    extra: prop_types.node
};
/* harmony default export */ var AppError_ErrorLayout = (ErrorLayout);

// EXTERNAL MODULE: ./src/AppError/mapGraphQLErrors.js
var mapGraphQLErrors = __webpack_require__(20522);
// EXTERNAL MODULE: ./locales/errors-page/index.js
var errors_page = __webpack_require__(88054);
var errors_page_default = /*#__PURE__*/__webpack_require__.n(errors_page);
;// CONCATENATED MODULE: ./src/AppError/AppError.js














const errorComponents = {
    400: AppError_Error400,
    401: AppError_Error401,
    403: AppError_Error403,
    404: AppError_Error404
};
const AppError = (param)=>{
    let { error  } = param;
    const { code  } = error;
    const ErrorComponent = errorComponents[code] || AppError_Error500;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppError_ErrorLayout, {
        extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppError_ErrorDetails, {
            error: error
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent, {
            error: error
        })
    });
};
AppError.getInitialProps = (context)=>{
    const { err , res  } = context;
    const appErr = (0,mapGraphQLErrors/* default */.ZP)(err);
    if (res) {
        res.statusCode = appErr.code;
    }
    if (appErr.code >= 500 && appErr.originalError != null) throw appErr.originalError;
    return {
        error: appErr.toSerializable()
    };
};
AppError.propTypes = {
    error: error_prop_type/* default */.Z
};
/* harmony default export */ var AppError_AppError = ((0,pipe/* default */.Z)(AppError, (0,i18/* WithLocale */._t)({
    resources: (errors_page_default())
})));

// EXTERNAL MODULE: ./node_modules/@apollo/react-hooks/lib/react-hooks.esm.js
var react_hooks_esm = __webpack_require__(18499);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ApplicationError/index.js
var ApplicationError = __webpack_require__(66651);
// EXTERNAL MODULE: ./src/graphql-local/unexpectedError/index.js + 3 modules
var unexpectedError = __webpack_require__(51041);
// EXTERNAL MODULE: ./src/sentry.js + 69 modules
var sentry = __webpack_require__(51720);
// EXTERNAL MODULE: ./src/utils/nav-hooks/useQueryString.js
var useQueryString = __webpack_require__(88046);
;// CONCATENATED MODULE: ./src/AppError/withErrorHandlingHoC.js










const withErrorHandlingHoC = (Component)=>{
    const WithErrorHandling = (param)=>{
        let { error , ...props } = param;
        const { data  } = (0,react_hooks_esm/* useQuery */.aM)(unexpectedError/* getUnexpectedError */.c);
        const asPath = nav_hooks_useCurrentPath();
        const query = (0,useQueryString/* default */.Z)();
        react.useEffect(()=>{
            if ((data === null || data === void 0 ? void 0 : data.unexpectedError) == null) return;
            (0,sentry/* notifySentry */.Yw)(ApplicationError/* default.of */.Z.of(data.unexpectedError), {
                asPath,
                query
            });
        }, [
            data === null || data === void 0 ? void 0 : data.unexpectedError
        ]);
        if (error == null && (data === null || data === void 0 ? void 0 : data.unexpectedError) == null) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                ...props
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppError_AppError, {
            error: error || ApplicationError/* default.of */.Z.of(data.unexpectedError)
        });
    };
    WithErrorHandling.propTypes = AppError_AppError.propTypes;
    WithErrorHandling.getInitialProps = (context)=>{
        try {
            const props = Component.getInitialProps ? Component.getInitialProps(context) : {};
            return (0,fn/* isPromise */.tI)(props) ? props.catch((err)=>AppError_AppError.getInitialProps({
                    ...context,
                    err
                })) : props;
        } catch (err) {
            return AppError_AppError.getInitialProps({
                ...context,
                err
            });
        }
    };
    return WithErrorHandling;
};
/* harmony default export */ var AppError_withErrorHandlingHoC = (withErrorHandlingHoC);

;// CONCATENATED MODULE: ./src/AppError/index.js





const withErrorHandling = (0,fn/* compose */.qC)(AppError_withErrorHandlingHoC, config/* publicConfig.DEBUG_MODE */.mn.DEBUG_MODE ? (0,ForceErrorHoC/* withForceError */.B)("throw") : fn/* idX */.Yr);
/* harmony default export */ var src_AppError = (AppError_AppError);


/***/ }),

/***/ 20522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I3": function() { return /* binding */ isNotFound; },
/* harmony export */   "_j": function() { return /* binding */ isNotAuthorized; }
/* harmony export */ });
/* unused harmony exports isGraphQLErrorIn, isBadRequest, isNotPermitted, isNetwork */
/* harmony import */ var _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66651);
/* eslint-disable no-nested-ternary, prettier/prettier */ 
const isGraphQLErrorIn = function() {
    for(var _len = arguments.length, codes = new Array(_len), _key = 0; _key < _len; _key++){
        codes[_key] = arguments[_key];
    }
    return (param)=>{
        let { graphQLErrors  } = param;
        return graphQLErrors && graphQLErrors.length && codes.includes(graphQLErrors[0].code);
    };
};
const isBadRequest = isGraphQLErrorIn(400, "INTERNAL_SERVER_ERROR");
const isNotAuthorized = isGraphQLErrorIn(401);
const isNotFound = isGraphQLErrorIn(400, 404);
const isNotPermitted = isGraphQLErrorIn(403);
const isNetwork = (param)=>{
    let { networkError  } = param;
    return networkError != null;
};
const mapGraphQLErrors = (error)=>isBadRequest(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error, 400) : isNotAuthorized(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error, 401) : isNotPermitted(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error, 403) : isNotFound(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error, 404) : isNetwork(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error) : _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"].of */ .Z.of(error);
/* harmony default export */ __webpack_exports__["ZP"] = (mapGraphQLErrors);


/***/ }),

/***/ 31927:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/** @type{(
	ctx: any, 
	services: { sgApiClient: import("../interfaces/ISGApiClient").ISGApiClient }
) => Promise<import("../interfaces/ISGApiClient").PlasmidSet> } */ const sets = (_, param)=>{
    let { sgApiClient  } = param;
    return sgApiClient.getSets();
};
/* harmony default export */ __webpack_exports__["Z"] = (sets);


/***/ }),

/***/ 27404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$b": function() { return /* binding */ ROUTE_PLASMIDS; },
/* harmony export */   "Bi": function() { return /* binding */ ALIAS_PET_AND_DUET_VECTORS_NOVAGEN; },
/* harmony export */   "J$": function() { return /* binding */ ROUTE_DOMAIN_PROD; },
/* harmony export */   "Re": function() { return /* binding */ ALIAS_PBR322; },
/* harmony export */   "XX": function() { return /* binding */ ROUTE_HOME; },
/* harmony export */   "aP": function() { return /* binding */ ALIAS_PEGFP_N1; },
/* harmony export */   "bF": function() { return /* binding */ ALIAS_PET_28A_PLUS; },
/* harmony export */   "nn": function() { return /* binding */ ALIAS_FLUORESCENT_PROTEIN_GENES_AND_PLASMIDS; },
/* harmony export */   "o$": function() { return /* binding */ ALIAS_PUC19; },
/* harmony export */   "oc": function() { return /* binding */ ALIAS_BASIC_CLONING_VECTORS; },
/* harmony export */   "qd": function() { return /* binding */ ROUTE_FREE_TRIAL; },
/* harmony export */   "ql": function() { return /* binding */ ROUTE_CONTACT_US; },
/* harmony export */   "u": function() { return /* binding */ ROUTE_SNAPGENE_VIEWER; }
/* harmony export */ });
/* unused harmony export ROUTE_PLASMID_FILES */
const ROUTE_DOMAIN_PROD = "www.snapgene.com";
const ROUTE_HOME = "/";
const ROUTE_PLASMIDS = "/plasmids";
const ROUTE_PLASMID_FILES = "".concat(ROUTE_PLASMIDS, "/sequences");
const ROUTE_SNAPGENE_VIEWER = "/snapgene-viewer";
const ROUTE_FREE_TRIAL = "/free-trial";
const ROUTE_CONTACT_US = "/contact";
const ALIAS_BASIC_CLONING_VECTORS = "basic_cloning_vectors";
const ALIAS_FLUORESCENT_PROTEIN_GENES_AND_PLASMIDS = "fluorescent_protein_genes_and_plasmids";
const ALIAS_PET_AND_DUET_VECTORS_NOVAGEN = "pet_and_duet_vectors_(novagen)";
const ALIAS_PET_28A_PLUS = "pET-28a(%2B)";
const ALIAS_PUC19 = "pUC19";
const ALIAS_PBR322 = "pBR322";
const ALIAS_PEGFP_N1 = "pEGFP-N1";


/***/ }),

/***/ 55093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ serviceCore; }
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89032);

const serviceCore = {
    sgApiConfig: ()=>({
            baseUrl: _config__WEBPACK_IMPORTED_MODULE_0__/* .publicConfig.SG_API_BASE_URL */ .mn.SG_API_BASE_URL
        })
};


/***/ }),

/***/ 96373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ services_sgApiClient; }
});

;// CONCATENATED MODULE: ./src/Plasmids/utils/throw-error.js
const throwError = (message)=>{
    throw new Error(message);
};

// EXTERNAL MODULE: ./src/Plasmids/utils/encodeURLFragment.js
var encodeURLFragment = __webpack_require__(20566);
;// CONCATENATED MODULE: ./src/Plasmids/utils/unescape.js
const htmlUnescapes = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&reg;": "\xae"
};
/** Used to match HTML entities and HTML characters. */ const reEscapedHtml = /&(?:amp|lt|gt|quot|reg);/g;
const reHasEscapedHtml = RegExp(reEscapedHtml.source);
/**
 * Converts the HTML entities `&amp;`, `&lt;`, `&gt;`, `&quot;` and `&#39;` `&reg;` in `string`
 */ const unescape_unescape = (string)=>{
    return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, (entity)=>htmlUnescapes[entity] || "'") : string || "";
};

;// CONCATENATED MODULE: ./src/Plasmids/domain/prepare-plasmids.js


const prepareSetData = (setData)=>({
        ...setData,
        plasmidSetName: unescape_unescape(setData.plasmidSetName),
        plasmidSetDesc: unescape_unescape(setData.plasmidSetDesc)
    });
const prepareSequence = (sequence)=>({
        ...sequence,
        plasmidID: (0,encodeURLFragment/* encodeURLFragment */.Q)(sequence.plasmidID)
    });
const prepareSequences = (sequencesSet)=>({
        ...sequencesSet,
        setData: sequencesSet.setData != null ? prepareSetData(sequencesSet.setData) //
         : null,
        sequences: sequencesSet.sequences.map(prepareSequence)
    });
const preparePlasmid = (plasmid)=>({
        ...plasmid,
        plasmidID: (0,encodeURLFragment/* encodeURLFragment */.Q)(plasmid.plasmidID),
        setID: (0,encodeURLFragment/* encodeURLFragment */.Q)(plasmid.setID)
    });

;// CONCATENATED MODULE: ./src/Plasmids/services/sgApiClient.js
/* eslint-disable no-console */ /** @typedef {import("@insightfulscience/shared-utils/http-client/types").IHttpClient} IHttpClient */ /** @typedef {import("../interfaces/ISGApiClient").ISGApiClient} ISGApiClient */ 

/** @type {(conn: IHttpClient) => ISGApiClient} */ const sgApiClient = (param)=>{
    let { get  } = param;
    return {
        getSets: ()=>get("plasmids/sets").then((param)=>// prettier-ignore
            {
                let { status , statusText , body  } = param;
                return status === 200 ? body.sets.map(prepareSetData) : status === 404 ? [] : throwError("Failed to fetch sets: ".concat(status, " - ").concat(statusText));
            }),
        getSequences: (setId)=>get("plasmids/sequences/".concat(setId)).then((param)=>// prettier-ignore
            {
                let { status , statusText , body  } = param;
                return status === 200 ? prepareSequences(body) : status === 404 ? null : throwError("Failed to fetch sequences of set #".concat(setId, ": ").concat(status, " - ").concat(statusText));
            }),
        getPlasmid: (setId, plasmidId)=>get("plasmids/sequences/".concat(setId, "/plasmid/").concat(plasmidId)).then((param)=>// prettier-ignore
            {
                let { status , statusText , body  } = param;
                return status === 200 ? preparePlasmid(body.plasmid) : status === 404 ? null : throwError("Failed to fetch plasmid #".concat(setId, "/").concat(plasmidId, ": ").concat(status, " - ").concat(statusText));
            }),
        getPlasmidContentMap: (setId, plasmidId)=>get("plasmids/map-content/".concat(setId, "/plasmid/").concat(plasmidId, "?token=map1&fast=0")).then((param)=>// prettier-ignore
            {
                let { status , statusText , body  } = param;
                return status === 200 ? body : status === 404 ? null : throwError("Failed to fetch plasmid content map #".concat(setId, "/").concat(plasmidId, ": ").concat(status, " - ").concat(statusText));
            }),
        getPlasmidStaticImage: (setId, plasmidId)=>get("plasmids/sequences/".concat(setId, "/plasmid/").concat(plasmidId, "/static-image")).then((param)=>// prettier-ignore
            {
                let { status , statusText , body  } = param;
                return status === 200 ? body.url : status === 404 ? null : throwError("Failed to fetch plasmid static image #".concat(setId, "/").concat(plasmidId, ": ").concat(status, " - ").concat(statusText));
            }),
        searchPlasmid: (string)=>get("plasmids/search", {
                query: {
                    string
                }
            }).then((param)=>// prettier-ignore
            {
                let { status , statusText , body  } = param;
                return status === 200 ? body.map(prepareSequences) : status === 404 ? [] : throwError('Failed to search plasmids matching "'.concat(string, '": ').concat(status, " - ").concat(statusText));
            }),
        getSequenceLineHeights: function(setId, plasmidId, length) {
            let { token ="seq1" , enzymes =1 , features =1 , primers =1 , translations =0  } = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
            return get("plasmids/sequence-content/".concat(setId, "/plasmid/").concat(plasmidId), {
                query: {
                    token,
                    enzymes,
                    features,
                    primers,
                    translations,
                    length,
                    asJson: 1
                }
            }).then((param)=>// prettier-ignore
            {
                let { status , statusText , body  } = param;
                return status === 200 ? body : status === 404 ? null : throwError("Failed to fetch plasmid static image #".concat(setId, "/").concat(plasmidId, ": ").concat(status, " - ").concat(statusText));
            });
        },
        getSequenceLine: function(setId, plasmidId, length, base) {
            let { enzymes =1 , features =1 , primers =1 , translations =0  } = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
            return get("plasmids/sequence-line/".concat(setId, "/plasmid/").concat(plasmidId), {
                query: {
                    length,
                    base,
                    enzymes,
                    features,
                    primers,
                    translations
                }
            }).then((result)=>result.ok ? result.body : "");
        }
    };
};
/* harmony default export */ var services_sgApiClient = (sgApiClient);


/***/ }),

/***/ 41674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _insightfulscience_shared_utils_http_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71195);

const sgApiConnection = (fetchFn, baseUrl)=>(0,_insightfulscience_shared_utils_http_client__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(fetchFn, {
        baseUrl,
        mode: "cors"
    });
/* harmony default export */ __webpack_exports__["Z"] = (sgApiConnection);


/***/ }),

/***/ 87149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ BlockAutocomplete_BlockAutocomplete; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Autocomplete/index.js + 1 modules
var Autocomplete = __webpack_require__(40539);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Autocomplete/Loader.js + 2 modules
var Loader = __webpack_require__(67909);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Autocomplete/Field.js
var Field = __webpack_require__(20466);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Autocomplete/Dropdown.js
var Dropdown = __webpack_require__(7150);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Autocomplete/DropdownGroupLabel.js
var DropdownGroupLabel = __webpack_require__(36219);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Autocomplete/DropdownItem.js
var DropdownItem = __webpack_require__(52004);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Autocomplete/DropdownItemLink.js
var DropdownItemLink = __webpack_require__(27367);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Autocomplete/DropdownGroup.js
var DropdownGroup = __webpack_require__(7511);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/NextLink/index.js
var NextLink = __webpack_require__(5098);
// EXTERNAL MODULE: ./src/Plasmids/utils/plasmid/helpers.js
var helpers = __webpack_require__(80702);
;// CONCATENATED MODULE: ./src/Plasmids/ui/BlockAutocomplete/ResultItem.js









const ResultItem = (param)=>{
    let { sequences , setData , onItemSelected , ...props } = param;
    return sequences.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownGroup/* default */.Z, {
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownGroupLabel/* default */.Z, {
                dangerouslySetInnerHTML: {
                    __html: setData.plasmidSetName
                }
            }),
            sequences.map((sequence)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownItem/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                        Component: DropdownItemLink/* default */.Z,
                        onClick: onItemSelected,
                        href: (0,helpers/* routePlasmid */.uT)(setData.set, sequence.plasmidID),
                        children: (0,helpers/* correctPlasmidName */.ev)(sequence)
                    })
                }, sequence.plasmidName);
            })
        ]
    }) : null;
};
ResultItem.propTypes = {
    setData: (0,prop_types.shape)({
        set: prop_types.string.isRequired,
        plasmidSetName: prop_types.string.isRequired
    }),
    sequences: (0,prop_types.arrayOf)((0,prop_types.shape)({
        plasmidID: prop_types.string.isRequired,
        plasmidName: prop_types.string.isRequired
    })),
    onItemSelected: prop_types.func
};
/* harmony default export */ var BlockAutocomplete_ResultItem = (ResultItem);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hooks/useFormAction.js
var useFormAction = __webpack_require__(44993);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/either/index.js + 1 modules
var either = __webpack_require__(71970);
;// CONCATENATED MODULE: ./src/Plasmids/providers/searchPlasmid.js

/** @typedef {import("../interfaces/ISGApiClient").ISGApiClient} ISGApiClient */ /** @typedef {import("../interfaces/ISGApiClient").PlasmidSequences} PlasmidSequences */ /** @type {
	(query: string) =>
	(deps: { sgApiClient: ISGApiClient }) => Promise<Right<{ query: string, plasmid:PlasmidSequences[] }>>
} */ const searchPlasmid = (query)=>(param)=>{
        let { sgApiClient  } = param;
        return sgApiClient.searchPlasmid(query).then((plasmid)=>(0,either/* Right */.O6)({
                query,
                plasmid
            }));
    };
/* harmony default export */ var providers_searchPlasmid = (searchPlasmid);

// EXTERNAL MODULE: ./src/Plasmids/utils/async-effects.js
var async_effects = __webpack_require__(79824);
;// CONCATENATED MODULE: ./src/Plasmids/ui/BlockAutocomplete/useSearchPlasmid.js




function useSearchPlasmid(input) {
    const [action, { result  }] = (0,useFormAction/* default */.Z)(providers_searchPlasmid);
    const runSearchPlasmid = (0,react.useMemo)(()=>(0,async_effects/* debounce */.Ds)(action, 500), [
        action
    ]);
    (0,react.useEffect)(()=>{
        if (input.length > 0) runSearchPlasmid(input);
    }, [
        input
    ]);
    const { query ="" , plasmid =[]  } = result !== null && result !== void 0 ? result : {};
    const isLoading = input.length > 0 && input !== query;
    const total = plasmid.reduce((prev, current)=>{
        return prev + current.sequences.length;
    }, 0);
    const isAnyMatch = total > 0;
    return {
        isLoading,
        isAnyMatch,
        plasmid,
        total
    };
}

;// CONCATENATED MODULE: ./src/Plasmids/ui/BlockAutocomplete/BlockAutocomplete.js








const BlockAutocomplete = ()=>{
    const [input, setInput] = (0,react.useState)("");
    const { isLoading , isAnyMatch , plasmid  } = useSearchPlasmid(input.trim());
    const resetInput = (0,react.useCallback)(()=>setInput(""), []);
    const handleInput = (0,react.useCallback)((param)=>{
        let { target  } = param;
        return setInput(target.value);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Autocomplete/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                iconName: "search",
                placeholder: "Search Plasmids",
                onChange: handleInput,
                value: input
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                display: input.length > 0,
                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {}) : isAnyMatch ? plasmid.map((param)=>/*#__PURE__*/ {
                    let { sequences , setData  } = param;
                    return (0,jsx_runtime.jsx)(BlockAutocomplete_ResultItem, {
                        sequences: sequences,
                        setData: setData,
                        onItemSelected: resetInput
                    }, setData.plasmidSetName);
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "No matches"
                })
            })
        ]
    });
};
/* harmony default export */ var BlockAutocomplete_BlockAutocomplete = (BlockAutocomplete);

;// CONCATENATED MODULE: ./src/Plasmids/ui/BlockAutocomplete/index.js



/***/ }),

/***/ 18570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ PageNavbarSearchLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25522);



const PageNavbarSearchLink = (param)=>/*#__PURE__*/ {
    let { ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        sx: {
            fontColor: "black",
            hover: {
                fontColor: "3"
            }
        },
        className: "text-underline",
        ...props
    });
};


/***/ }),

/***/ 97703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SectionItems_SectionItems; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/LandingElement/SimpleSection.js
var SimpleSection = __webpack_require__(72989);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
;// CONCATENATED MODULE: ./src/Plasmids/utils/colToRows.js
const colToRows = (colsCount, column)=>{
    const { length  } = column;
    // eslint-disable-next-line no-param-reassign
    colsCount = Math.min(colsCount, length) || 1;
    const fullColsCount = length % colsCount || colsCount;
    const fullRowsCount = Math.floor(length / colsCount);
    const rowsCount = Math.ceil(length / colsCount);
    const shortColumnOffset = rowsCount * fullColsCount;
    return Array.from({
        length: rowsCount
    }, (_, row)=>Array.from({
            length: row < fullRowsCount ? colsCount : fullColsCount
        }, (__, col)=>col < fullColsCount ? column[col * rowsCount + row] : column[shortColumnOffset + (col - fullColsCount) * fullRowsCount + row]));
};
/* harmony default export */ var utils_colToRows = (colToRows);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/NextLink/index.js
var NextLink = __webpack_require__(5098);
// EXTERNAL MODULE: ./src/Plasmids/routes/index.js
var routes = __webpack_require__(27404);
// EXTERNAL MODULE: ./src/Plasmids/utils/plasmid/helpers.js
var helpers = __webpack_require__(80702);
;// CONCATENATED MODULE: ./src/Plasmids/ui/SectionItems/renderItem.js








const setProps = (param)=>{
    let { plasmidSetName , set , plasmidSetDesc  } = param;
    return {
        id: set,
        title: plasmidSetName,
        description: plasmidSetDesc,
        selected: false
    };
};
const plasmidProps = (setID, currentPlasmidID, param)=>{
    let { plasmidName , customMapLabel , plasmidID  } = param;
    return {
        id: "".concat(setID, "/").concat(plasmidID),
        title: (0,helpers/* correctPlasmidName */.ev)({
            plasmidName,
            customMapLabel
        }),
        description: "",
        selected: plasmidID === currentPlasmidID
    };
};
const renderItem = (param)=>{
    let { TagLink =Link/* default */.Z , TagDescription =Paragraph/* default */.Z , isSet =false , hasDescription =false , setID , colWidth , plasmidID  } = param;
    return (item)=>{
        const { title , description , id , selected  } = isSet ? setProps(item) : plasmidProps(setID, plasmidID, item);
        const spacingProps = isSet ? {
            py: 2
        } : {};
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
            md: colWidth,
            spacing: spacingProps,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                    Component: TagLink,
                    href: "".concat(routes/* ROUTE_PLASMIDS */.$b, "/").concat(id),
                    className: selected ? "text-color-red" : "",
                    dangerouslySetInnerHTML: {
                        __html: title
                    }
                }),
                hasDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TagDescription, {
                    className: "my-0",
                    dangerouslySetInnerHTML: {
                        __html: description
                    }
                }) : null
            ]
        }, id);
    };
};

;// CONCATENATED MODULE: ./src/Plasmids/ui/SectionItems/SectionItems.js
/* eslint-disable react/no-array-index-key */ 








const SectionItems = (param)=>{
    let { TagLink =Link/* default */.Z , TagDescription =Paragraph/* default */.Z , type , title , colCount =4 , hasDescription =false , setID , plasmidID , items  } = param;
    const itemsSorted = (0,react.useMemo)(()=>{
        const isSet = type === "set";
        return isSet ? items.sort((a, b)=>{
            const itemA = a.plasmidSetName.toLowerCase();
            const itemB = b.plasmidSetName.toLowerCase();
            return itemA < itemB ? -1 : itemA > itemB ? 1 : 0; // eslint-disable-line
        }) : items.sort((a, b)=>{
            const itemA = a.customMapLabel.toLowerCase();
            const itemB = b.customMapLabel.toLowerCase();
            return itemA < itemB ? -1 : itemA > itemB ? 1 : 0; // eslint-disable-line
        });
    }, [
        items,
        type
    ]);
    const rows = (0,react.useMemo)(()=>utils_colToRows(colCount, itemsSorted !== null && itemsSorted !== void 0 ? itemsSorted : []), [
        colCount,
        itemsSorted
    ]);
    const itemProps = (0,react.useMemo)(()=>({
            setID,
            plasmidID,
            TagLink,
            TagDescription,
            hasDescription,
            isSet: type === "set",
            colWidth: Math.round(12 / colCount)
        }), [
        setID,
        plasmidID,
        TagLink,
        TagDescription,
        hasDescription,
        colCount
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSection/* default */.Z, {
        isBorderNone: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.TitleV2 */.Z.TitleV2, {
                spacing: {
                    mb: 10
                },
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.Body */.Z.Body, {
                children: rows.map((row, rowIndex)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                        mx: true,
                        children: row.map(renderItem(itemProps))
                    }, "".concat(title, "_").concat(rowIndex)))
            })
        ]
    });
};
SectionItems.propTypes = {
    TagLink: prop_types.elementType,
    TagDescription: prop_types.elementType,
    title: prop_types.string.isRequired,
    type: (0,prop_types.oneOf)([
        "set",
        "sequence"
    ]).isRequired,
    setID: prop_types.string,
    plasmidID: prop_types.string,
    hasDescription: prop_types.bool,
    colCount: prop_types.number,
    items: (0,prop_types.arrayOf)(prop_types.object)
};
/* harmony default export */ var SectionItems_SectionItems = (SectionItems);

;// CONCATENATED MODULE: ./src/Plasmids/ui/SectionItems/index.js



/***/ }),

/***/ 79824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ds": function() { return /* binding */ debounce; }
/* harmony export */ });
/* unused harmony exports chain, chainResults */
const chain = (fn)=>{
    let prev = null;
    let count = 0;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return new Promise((resolve, reject)=>{
            count += 1;
            const task = ()=>fn(...args).then(resolve, reject);
            prev = prev != null ? prev.finally(task) : task();
            return prev.finally(()=>{
                count -= 1;
                if (count === 0) prev = null;
            });
        });
    };
};
const chainResults = (fn)=>{
    let prev = null;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        prev = Promise.all([
            fn(...args),
            prev
        ]);
        return prev.then((res)=>res[0]);
    };
};
const debounce = (fn, wait)=>{
    let timerId = null;
    const resetTimer = ()=>{
        timerId = null;
    };
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return new Promise((resolve, reject)=>{
            if (timerId != null) clearTimeout(timerId);
            timerId = setTimeout(()=>fn(...args).then(resolve, reject).finally(resetTimer), wait);
        });
    };
};


/***/ }),

/***/ 20566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ encodeURLFragment; }
/* harmony export */ });
const encodeURLFragment = (input)=>{
    return encodeURIComponent(input).replace("'", "%27");
};


/***/ }),

/***/ 80702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ev": function() { return /* binding */ correctPlasmidName; },
/* harmony export */   "nA": function() { return /* binding */ routeSet; },
/* harmony export */   "uT": function() { return /* binding */ routePlasmid; }
/* harmony export */ });
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27404);

const correctPlasmidName = (data)=>data.plasmidName;
const routeSet = (setID)=>"".concat(_routes__WEBPACK_IMPORTED_MODULE_0__/* .ROUTE_PLASMIDS */ .$b, "/").concat(setID);
const routePlasmid = (setID, plasmidID)=>"".concat(_routes__WEBPACK_IMPORTED_MODULE_0__/* .ROUTE_PLASMIDS */ .$b, "/").concat(setID, "/").concat(plasmidID);


/***/ }),

/***/ 98106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19334);
/* harmony import */ var _insightfulscience_smart_react_Html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73972);
/* harmony import */ var _insightfulscience_atomic_react_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18774);
/* harmony import */ var _insightfulscience_i18__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46003);






const SectionTryForFree = ()=>{
    const [t] = (0,_insightfulscience_i18__WEBPACK_IMPORTED_MODULE_5__/* .useLocale */ .bU)("section-try-for-free");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Title */ .Z.Title, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_smart_react_Html__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    Tag: "span",
                    children: t("TRY_FREE_TEXT")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Action */ .Z.Action, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Link */ .Z.Link, {
                    href: "/free-trial",
                    size: "s",
                    className: "ml-auto mr-auto",
                    children: t("TRY_FREE_BUTTON_TEXT")
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SectionTryForFree);


/***/ }),

/***/ 88046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _insightfulscience_smart_react_url_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89333);
/* harmony import */ var _global_context_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63841);




function useQueryString() {
    const context = (0,_global_context_hook__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { asPath  } = router || context;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>(0,_insightfulscience_smart_react_url_query__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(asPath), [
        asPath
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useQueryString);


/***/ }),

/***/ 50389:
/***/ (function(module) {

module.exports = JSON.parse('{"MONTH":["January","February","March","April","May","June","July","August","September","October","November","December"]}');

/***/ }),

/***/ 1578:
/***/ (function(module) {

module.exports = JSON.parse('{"MONTH":["January","February","March","April","May","June","July","August","September","October","November","December"],"META_IMAGE":"/images/snapgene/plasmid-files/og-image.png","META_IMAGE_SECURE":"/images/snapgene/plasmid-files/og-image.png","META_TWITTER_IMAGE":"/images/snapgene/plasmid-files/og-image.png","HOME":"Home","PLASMIDS":"Plasmids","TRY_SNAPGENE_FOR_FREE":"Try SnapGene for Free","DOWNLOAD_SNAPGENE_VIEWER":"Download SnapGene Viewer","DOWNLOAD_PLASMID":"Download Plasmid","DOWNLOAD_PLASMID_SET":"Download Plasmid Set","DOWNLOAD_SNAPGENE":"Download SnapGene","DOWNLOAD_GENOMES":"Download Genomes","MORE_PLASMID_SETS":"More Plasmid Sets","INDIVIDUAL_SEQUENCES_MAPS":"Individual Sequences & Maps","PLASMID_SETS":"Plasmid Sets","SHOW_INTERACTIVE_MAP":"Show Interactive Map","SHOW_STATIC_MAP":"Show Static Map","OPEN_IN_SNAPGENE":"Open in SnapGene","SNAPGENE_VIEWER":"SnapGene Viewer","GENOMES_AND_PRIMERS":"Genomes and Primers","EXPLORE_OVER_PLASMIDS":"Explore Over 2.7k Plasmids","EXPLORE_OVER_PLASMIDS_INCLUDING":"Explore Over 2.7k Plasmids including"}');

/***/ }),

/***/ 3049:
/***/ (function(module) {

module.exports = JSON.parse('{"TRY_FREE_TEXT":"Discover the most <b>user-friendly</b> molecular biology experience.","TRY_FREE_BUTTON_TEXT":"Try for Free"}');

/***/ }),

/***/ 33686:
/***/ (function(module) {

module.exports = JSON.parse('{"TRY_FREE_TEXT":"Discover the most <b>user-friendly</b> molecular biology experience.","TRY_FREE_BUTTON_TEXT":"Try for Free"}');

/***/ })

}]);